import WhichEnv from '@ally/which-env';

// Returns an object with the following convenience methods & properties:
// whichEnv.name
// whichEnv.isDev (name === 'dev')
// whichEnv.isLocal (name === 'local')
// whichEnv.isDevLike (isDev || isLocal)
// whichEnv.isQA (!!name.startsWith('qa') || name === 'fix')
// whichEnv.isCap (name === 'cap')
// whichEnv.isProd (!isCap && !isQA && !isDev && !isLocal)
// const url = whichEnv.pick({
//   prod: 'http://prod.foo',
//   local: 'http://local.foo',
// })

export const whichEnv = WhichEnv(undefined, [ // eslint-disable-line babel/new-cap
  ['dev', /.*-dev/],
  ['qabi1', /.*-qabi1/],
  ['qabi2', /.*-qabi2/],
  ['local', /^localhost|0\.0\.0\.0|127\.0\.0\.1/],
  ['prod', /.*/],
]);
